import {KpiType} from '@hconnect/common/types'

import {PERFORMANCE_REVIEW_KPI_TYPES} from '../consts'

import {ActualDeltaChipProps, NegativeActualDelta, PositiveActualDelta} from './KpiChip'

type PerformanceReviewKpi = (typeof PERFORMANCE_REVIEW_KPI_TYPES)[number]

export const PerformanceReviewKpiTemplates: Record<
  PerformanceReviewKpi,
  React.FC<ActualDeltaChipProps>
> = {
  [KpiType.ClinkerProduction]: PositiveActualDelta,
  [KpiType.CementProduction]: PositiveActualDelta,
  [KpiType.AlternativeFuelRate]: PositiveActualDelta,
  [KpiType.KilnHeatConsumption]: NegativeActualDelta,
  [KpiType.TechnicalCementPowerConsumption]: NegativeActualDelta,
  [KpiType.ClinkerIncorporation]: NegativeActualDelta,
  [KpiType.CO2EmissionsPerCement]: NegativeActualDelta,
  [KpiType.MaintenanceCosts]: NegativeActualDelta,
  [KpiType.KilnReliabilityCoefficient]: PositiveActualDelta,
  [KpiType.KilnOperatingCoefficient]: PositiveActualDelta,
  [KpiType.KilnMTBF]: PositiveActualDelta,
  [KpiType.FinishMillOperatingCoefficient]: PositiveActualDelta
}
